import { useQuery } from 'react-query';
import { axios, AxiosQueryResponse } from '../../../utils/axios';
import { apiResourceLinks } from '../../../constants/apiResourceLinks';
import { AccountChangeRequest, PaginatedRequest, PaginatedResponse } from '../../../types/request';
import { usePermissions } from '../../../providers/PermissionsProvider';
import { acrDefaultSortingInfo, usePaginationRequestInfo } from '../../../providers/PaginationRequestProvider';
import { usePaginationRequestInput } from '../../../hooks/usePaginationRequestInput';
import { FilterKey } from '../../../providers/FiltersProvider';

const getAccountChangeRequests = async (request: PaginatedRequest) => {
  const { data }: AxiosQueryResponse = await axios.post(apiResourceLinks.getAccountChangeRequests, request);
  return data;
};

export const useAccountChangeRequestsQuery = (activeFilterName?: FilterKey, pageName?: string) => {
  const { accountChangeRequestEnabled } = usePermissions();
  const { setPaginationInfo } = usePaginationRequestInfo(activeFilterName, pageName);
  const input = usePaginationRequestInput(activeFilterName, pageName, acrDefaultSortingInfo);
  const { requestQuery, paginationInfo, sortingInfo } = input;
  const enabled = accountChangeRequestEnabled && !!(input.sortingInfo && input.paginationInfo && input.requestQuery);
  return useQuery<PaginatedResponse<AccountChangeRequest>>(
    ['accountChangeRequests', requestQuery, paginationInfo?.pageNumber, paginationInfo?.pageSize, sortingInfo?.sortingBy, sortingInfo?.sortDirection],
    () => getAccountChangeRequests(input),
    {
      enabled,
      onSuccess: (data) => {
        setPaginationInfo(data.paginationInfo);
        return data;
      },
      onError: () => {}
    }
  );
};
